// frontend/src/pages/NotFoundPage.tsx
// PRC-029: 404 público con la estética de las pantallas de estado del
// recorrido: marca, explicación y salida clara.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SimpleLayout } from '../modules/pricingJourney/components/JourneyLayouts';
import { StatusBlock } from '../modules/pricingJourney/components/JourneyBlocks';
import { JourneyButton } from '../modules/pricingJourney/components/JourneyBasics';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <SimpleLayout narrow>
      <StatusBlock
        variant="info"
        centered
        title="No encontramos esta página"
        text="La dirección no existe o ha cambiado. Puedes volver al inicio o entrar en tu cuenta."
        actions={(
          <>
            <JourneyButton onClick={() => navigate('/')}>Ir al inicio</JourneyButton>
            <JourneyButton kind="ghost" onClick={() => navigate('/login')}>Iniciar sesión</JourneyButton>
          </>
        )}
      />
    </SimpleLayout>
  );
};

export default NotFoundPage;
